import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const MedNamePDF = ({
  med,
  indent
}) => {
  const indentStyle = indent ? styles.paddingLeftPointFiveCm : {};
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width40]
  }, med.drugdescription && /*#__PURE__*/React.createElement(Text, {
    style: [styles.medsTableMainDetailsText, indentStyle]
  }, `${med.drugdescription}`), med.sig ? /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontFamilyItalic, styles.fontSizeEightPt, indentStyle]
  }, med.sig) : null);
};